import React from 'react';

const NotFound = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-20 text-center">
      <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
      <p className="text-gray-700">The page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFound;
